import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

Vue.use(Vuex);

export const store  = new Vuex.Store({
  state: {
    admin: {
      id: 0,
      firstname: '',
      lastname: '',
      role: '',
      username: '',
      email: '',
      phone_number: '',
      line_id: '',
      profile_image_url: '',
      permission: [],
      _token: ''
    }
  },
  getters,
  mutations,
  actions
});